import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Dropdown, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';

import { useInterval, useRouter } from '../../../helpers/customHooks';
import {
  fixDecimals,
  getDataScope,
  getFile,
  getPlayerBallMetricsState,
  getTeamData,
  saveDataPlayersOnLocalStorage
} from '../../../helpers';
import * as DateFns from 'date-fns';
import { buildPlayerData } from '../../../store/actions';
import SimpleMultiSelector from '../../Shared/Filters/SimpleMultiSelector';
import DistanceGraph from '../../Shared/Graphics/DistanceGraphV2';
import { GaugeNFL as Gauge } from '../../Shared/Graphics/GaugeV3';
import Metric from '../../Shared/Metrics/Metric';
import DataPerformanceTab from './DataPerformanceTab';
import { ReactComponent as ChartLogo } from './graph-01.svg';
import { ReactComponent as DataLogo } from './data-01.svg';
import Bars from '../../Shared/Graphics/Bars';
import ZoneTypeFilter from '../../Shared/Filters/ZoneTypeFilter';
import { VelocityGraph } from '../../Shared/Graphics/VelocityGraph';
import Loader from '../../Shared/Loader';
import {
  BALL,
  FILTER_KEYS,
  FUTURE_PRACTICE,
  GAME,
  LIVE_PRACTICE,
  LOAD_EVENTS_TIME_LIVE_PAGE,
  MESSAGES,
  PAST_GAME,
  PAST_PRACTICE,
  PRACTICE,
  QUARTER,
  TEAM
} from '../../../config/constants';
import {
  useDataEventsDispatch,
  useDataEventsState,
  useDataPlayersDispatch,
  useFiltersState
} from '../../../store/hooks';
import { ModalRoutes, PlayerMetricsModalProps } from './types';
import { MetaDataPlayer } from '../../../store/types';
import { TeamData } from '../../../config/commonTypes';
import { dataPlayers } from 'store/reducers/dataPlayers';
import { notification } from 'antd';
import { SERVER } from 'config/server.config';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';

type ModalLabels = Array<{
  ballFlightModelList: Array<{
    flightType: string;
    peakHeightFt: number;
    airDistInYards: number;
    flightDurationSec: number;
    initialAirSpeedMPH: number;
    initialRotationRPM: number;
  }>
}>;

const PlayerBallMetricsModal = ({ show, onHide, initialTab, hidden, hasUpdate }: PlayerMetricsModalProps) => {

  const { dataEvent: data } = useDataEventsState();
  const { pathname: path, eventType, params, specificScope } = useRouter<ModalRoutes>();
  const { id: gameId, tab, playerId, teamId: paramTeamId } = params;
  const {
    [FILTER_KEYS.PERIODS]: selectedPeriods,
    [FILTER_KEYS.QUARTER]: selectedQuarters,
    [FILTER_KEYS.ZONE_TYPE]: selectedZoneType = TEAM
  } = useFiltersState(specificScope, FILTER_KEYS.PERIODS, FILTER_KEYS.QUARTER, FILTER_KEYS.ZONE_TYPE);
  const rendersCounter = useRef(0);

  const { replaceDataPlayers, updateDataPlayer } = useDataPlayersDispatch();
  const {
    getPastPracticeModalData,
    getLivePracticeModalData,
    getBallMetricsPracticeModalData
  } = useDataEventsDispatch();

  const {
    type,
    teamId,
    playerData,
    playerBallData,
    velocityGraphData
  } = getPlayerBallMetricsState(data, playerId);
  const {  fileIsDownloading } = useFlagsDispatch();
  const{ download } = useFlagsState();

  const pathValues = path.split('/');
  const flag = (pathValues.find((val) => (
    'condensed' === val
  )) || data.meta.type === LIVE_PRACTICE ? true : null);
  const dataScope = getDataScope(paramTeamId);
  const getData = useCallback((forceCall) => {
    if (data.meta.type === LIVE_PRACTICE) {
      getLivePracticeModalData(teamId, data[dataScope].players.length === 0 || forceCall);
      getBallMetricsPracticeModalData(false, true);
    }else{
      getBallMetricsPracticeModalData(data[dataScope].players.length === 0 || forceCall, false);
    }
    if ((data.meta.type === PAST_PRACTICE || data.meta.type === PAST_GAME) && (data[dataScope].players.length === 0 || forceCall)) {
      getPastPracticeModalData(data.meta.type === PAST_PRACTICE? teamId : paramTeamId);
    }
    
  }, [data[dataScope].players.length, data.meta.type, getBallMetricsPracticeModalData, getLivePracticeModalData, getPastPracticeModalData, teamId]); // teamId fot Games

  useEffect(() => {
    rendersCounter.current++;
    setTimeout(() => getData(true), 1000);
  }, [gameId, playerId, data.meta.type, hasUpdate]);

  useEffect(() => {
    if(selectedQuarters && rendersCounter.current > 3){
     getData(true);
    }else{
      rendersCounter.current++;
    }
  }, [selectedQuarters]);

  useEffect(() => {
    if (selectedPeriods && rendersCounter.current > 3) {
      getData(true);
    }else{
      rendersCounter.current++;
    }
  }, [selectedPeriods]);
  // live calls
  useInterval(() => getData(false),
    !hidden && data.meta.type === LIVE_PRACTICE ? LOAD_EVENTS_TIME_LIVE_PAGE : null);
  useEffect(() => {
    if (playerData) {
      const meta: MetaDataPlayer = {
        name: playerData.name,
        playerId: playerId,
        position: playerData.position,
        // positionGroup: playerData.positionGroup,
        // status: playerData.status,
        // sbeid: playerData.sbeid,
        teamId: playerData.teamId,
        jersey: playerData.jersey
        // eid: playerData.eid
      };
      updateDataPlayer({
        meta: meta,
        metrics: playerData.metrics
      });
    }
  }, [playerData]);
  const [showFilter, setShowFilter] = useState(-1);
  const [showFilter2, setShowFilter2] = useState(-1);
  // const list = [];
  const metrics: JSX.Element[] = [];
  const relative = (selectedZoneType === 'Player') ? 1 : 0;
  const custom = (selectedZoneType === 'Custom') ? 1 : 0;
  const distGraphMetrics = ["walkYds", "jogYds", "runYds", "sprintYds", "maxSprintYds"];
  const playerLiveData = data.data?.players[data.data.players.findIndex(x => x.id === playerId)] || playerData;

  const notificationKey = 'downloadFinished';
   const notificationDownload = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download In Progress',
       description:
         `Your file ${name} is being processed.`,
       duration: 0,
       icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadFinish = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download Finished',
       description: `Your file ${name} has been downloaded successfully.`,
       duration: 4,
       icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadError = (name:string) => {
     const args = {
       key: notificationKey,
       message: `Error downloading file ${name}`,
       duration: 4,
       icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
     };
     notification.open(args);
   };

  if (playerBallData) {
    if (playerBallData[0].playersList.length > 0) {
      const labels: ModalLabels = playerBallData[0].playersList[0].sessionList;
      labels.forEach((label) => {
        // list.push(<li key={label.sessionName + index}>
        //   <input
        //     className="styled-checkbox" id={`styled-checkbox-${index}`} type="checkbox" value={label.sessionName}
        //   />
        //   <label htmlFor={`styled-checkbox-${index}`} className="check-l">{label.sessionName}</label>
        // </li>);
        const flights = label.ballFlightModelList;
        flights.forEach((flight, index3: number) => {
          metrics.push(<tr key={index3}>
            <td>{flight.flightType}</td>
            <td className="l-c">{flight.initialAirSpeedMPH}</td>
            <td className="l-c">{flight.initialRotationRPM}</td>
            <td className="l-c">{flight.flightDurationSec}</td>
            <td className="l-c">{flight.peakHeightFt}</td>
            <td className="l-c">{flight.airDistInYards}</td>
          </tr>);
        });
      });
    }
  }
  const dataTeam = playerData && getTeamData(playerData.teamId) ? getTeamData(playerData.teamId) : {} as TeamData;
  const playerInfo = playerBallData ? playerBallData[0].playersList[0] : {};
  if (playerBallData && playerBallData[0].playersList.length === 0) {
    initialTab = 'performance-01';
  }
  const close = () => setShowFilter(-1);

  const periods = [...((data && data.meta && data.meta.drills) || [])];
  if (tab === BALL) {
    periods.unshift({
      drillType: 'Ball Pre-Practice',
      endTs: 0,
      session_id: 0,
      startTs: 0,
      state: ''
    });
  }
  return <>
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {playerData && playerData.metrics ?
        <>
        <Loader>
          <Modal.Header closeButton className="modal-practices">
            <Modal.Title id="contained-modal-title-vcenter">
              <div className="header-p">
                {/* <div className="p-img"
                style={{backgroundImage: `url(https://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/${playerData ? playerData.esbId : playerBallData.esbId}.png)`}}/> */}
                <div className="p-g">
                  <label className="p-01">
                    <Link
                      to={{ pathname: `/player/${playerId}` }} style={{ opacity: '1' }} onClick={() => {
                      const dataPlayer = buildPlayerData({ nid: playerId, ...playerData });
                      replaceDataPlayers({ [dataPlayer.meta.playerId]: dataPlayer })();
                      saveDataPlayersOnLocalStorage();
                    }}
                    >
                      {playerData ? playerData.name : playerInfo.name}
                    </Link>
                  </label>
                  <label className="p-02">
                    <img src={'/assets/images/logos/' + (dataTeam as TeamData).teamAbbrName + '.svg'} width="20px"
                         alt="" />
                    {(dataTeam as TeamData).teamFullName}
                    <span>•</span> #{playerData ? playerData.jersey : playerInfo.jerseyNumber}
                    <span>•</span> {playerData ? playerData.position : playerInfo.position}</label>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body-00">
            <Tabs
              defaultActiveKey={initialTab} id="uncontrolled-tab-example" className="modal-000" unmountOnExit
              mountOnEnter
            >
              {playerData ? <Tab eventKey="performance-01" title="Performance">
                <div className="modal-h-01">
                  {/*{type !== LIVE_PRACTICE &&*/}
                  {/*<PeriodSelector*/}
                  {/*  show={showFilter === 0}*/}
                  {/*  close={() => setShowFilter(-1)}*/}
                  {/*  open={() => setShowFilter(0)}*/}
                  {/*/>}*/}

                  {eventType === GAME && type !== FUTURE_PRACTICE && (
                    <SimpleMultiSelector
                      type={QUARTER}
                      show={showFilter === 2}
                      close={close}
                      open={() => setShowFilter(2)}
                    />
                  )}
                  {eventType === PRACTICE && type === PAST_PRACTICE && (
                    <SimpleMultiSelector
                      type={{
                        name: 'Period',
                        types: periods.map((period) => ({ value: period, name: period.drillType })),
                        title: 'PERIOD',
                        filterKey: FILTER_KEYS.PERIODS
                      }}
                      show={showFilter === 3}
                      close={close}
                      open={() => setShowFilter(3)}
                    />
                  )}
                  <ZoneTypeFilter
                    show={showFilter === 1}
                    close={close}
                    open={() => setShowFilter(1)}
                  />
                  {DateFns.isToday(data.meta.startTime) && eventType === PRACTICE && data.meta.type === PAST_PRACTICE && (
                    <Button
                className="btn-blue"
                style={ download ?{ opacity: 0.5, cursor: "default", pointerEvents: "none", height: '40px', width: '80px' } : {height: '40px', width: '80px'}}
                onClick={async () => {
                  fileIsDownloading(true);
                  notificationDownload(`${gameId}_${playerId}.csv`);
                  const done = await getFile(SERVER.CSV_INDIVIDUAL_EXPORT(gameId, playerId, -(new Date(data.meta.startTime).getTimezoneOffset())), 
                  `${gameId}_${playerId}.csv`);
                  if (done) {
                    fileIsDownloading(false);
                    notificationDownloadFinish(`${gameId}_${playerId}.csv`);
                  } else {
                    fileIsDownloading(false);
                    notificationDownloadError(`${gameId}_${playerId}.csv`);
                  }
                }}
                disabled={download}
              >
                Raw Export
              </Button>
                  )}
                </div>
                <Tabs defaultActiveKey="home" transition={false} id="noanim-tab-example" className="modal-001">
                  <Tab eventKey="home" title={<span><ChartLogo /> CHART</span>}>
                    <div className="tab-body">
                      <h6 style={{ marginBottom: '5px' }}>DISTANCE GRAPH (YDS)</h6>
                      <DistanceGraph
                        data={distGraphMetrics.map((metric)=>{
                          if(relative) return playerData.metrics[`${metric}Relative`];
                          if(custom) return playerData.metrics[`${metric}Custom`];
                          return playerData.metrics[metric];
                        })}
                        // data={[200,150,789,457,457]}
                        colors={['#00501E', '#4F9300', '#FB8C00', '#F45110', '#D6151c']}
                        width={770}
                        height={37}
                      />
                      <div className="example-02">
                        <div className="ex-06">
                          <div className="example-002"><label className="exa-01" /> Walk</div>
                          <div className="example-002"><label className="exa-02" /> Jog</div>
                          <div className="example-002"><label className="exa-03" /> Run</div>
                          <div className="example-002"><label className="exa-04" /> Sprint</div>
                          <div className="example-002"><label className="exa-05" /> Max Sprint</div>
                        </div>
                        <div className="ex-07">
                          <p>TOTAL DISTANCE (YDS) <span>{fixDecimals(playerData.metrics.totalDis, 0)}</span></p>
                          <p className="ex-07-p">{
                            Number.isInteger(+fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)) && +fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0) >= 0 ?
                            `(${fixDecimals(playerData.metrics['historyTotalDistance_%']* 100, 0)}%)` :
                            '-'}</p>
                        </div>
                      </div>
                      <div style={{ height: '180px' }}>
                        <Loader
                          forceMessage={velocityGraphData && velocityGraphData.length !== 0 ? undefined : MESSAGES.EMPTY}
                        >
                          <VelocityGraph data={velocityGraphData} width={770} height={150} periods={periods} />
                        </Loader>
                      </div>
                      <div className="popup-metrics">
                        <div className="metrics-div">
                          <h6>MAX SPEED (MPH)</h6>
                          <div className="gauge-player">
                            <Gauge
                              maxVel={23}
                              curVel={playerData.metrics.maxSpeedMPH > 23 ? 23 : playerData.metrics.maxSpeedMPH}
                              previousVel={(relative ? playerData.metrics['maxSpeedMPHAs%ofTarget_Relative'] : custom?  playerData.metrics['maxSpeedMPHAs%ofTarget_Custom']:
                                  playerData.metrics['maxSpeedMPHAs%ofTarget']) * 100}
                              compareFlag
                              popupFlag
                            />
                          </div>
                        </div>
                        <div className="metrics-div">
                          <h6>MAX SUSTAINED SPEED (MPH)</h6>
                          <div className="gauge-player">
                            <Gauge
                              maxVel={23}
                              curVel={playerData.metrics.maxSustainedSpeedMPH > 23 ? 23 : playerData.metrics.maxSustainedSpeedMPH}
                              previousVel={(relative ? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] : custom? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Custom'] :
                                playerData.metrics['maxSustSpeedMPHAs%ofTarget']) * 100}
                              targetVel={relative ? playerData.metrics.targetMPHRelative : custom? playerData.metrics.targetMPHCustom : playerData.metrics.targetMPH}
                              // tootTipText={relative ? }
                              compareFlag
                              popupFlag
                            />
                          </div>
                          <h4>Max Speed Held For At Least .5 Sec</h4>
                        </div>
                        <div className="metrics-div">
                          <h6 style={{ marginBottom: '8px' }}>ACCELS</h6>
                          <Bars
                            data={[playerData.metrics.accelSlow, playerData.metrics.accelMed, playerData.metrics.accelFast]}
                            // dataAVG={[Math.round(Math.random() * 10000), Math.round(Math.random() * 10000), Math.round(Math.random() * 10000)]}
                            colors={['#4F9300', '#FB8C00', '#D6151C']}
                            maxHeight={113}
                          />
                          <h5 style={{ position: 'relative' }}>Total
                            Accels <label>{playerData.metrics.accelSlow + playerData.metrics.accelMed + playerData.metrics.accelFast}</label><label
                              className={'accels-decels-style'}
                            >-</label></h5>
                        </div>
                        <div className="metrics-div-01">
                          <h6 style={{ marginBottom: '8px' }}>DECELS</h6>
                          <Bars
                            data={[playerData.metrics.deccelSlow, playerData.metrics.deccelMed, playerData.metrics.deccelFast]}
                            // dataAVG={[Math.round(Math.random() * 1000), Math.round(Math.random() * 1000), Math.round(Math.random() * 1000)]}
                            colors={['#4F9300', '#fb8a00', '#D6151C']}
                            maxHeight={113} top
                          />
                          <h5 style={{ position: 'relative' }}>Total
                            Decels <label>{playerData.metrics.deccelSlow + playerData.metrics.deccelMed + playerData.metrics.deccelFast}</label><label
                              className={'accels-decels-style'}
                            >-</label></h5>
                        </div>
                      </div>
                      <div className="ex-08">
                        <div className="example-002"><label className="exa-02" />Low</div>
                        <div className="example-002"><label className="exa-03" />Medium</div>
                        <div className="example-002"><label className="exa-05" />High</div>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="data" title={<span><DataLogo /> DATA</span>}>
                    <div className="tab-body data-body">
                      <DataPerformanceTab playerData={data.meta.type === LIVE_PRACTICE ? playerLiveData : playerData} selectedZoneType={selectedZoneType} flag={flag} />
                    </div>
                  </Tab>
                </Tabs>
              </Tab> : null}
              {(playerBallData && playerBallData[0].playersList.length > 0) && 
              (playerData.position === 'QB' || playerData.position === 'K' || playerData.position === 'P' || playerData.position === 'LS') ?
                <Tab eventKey='ball' title="Ball Metrics">
                  <div className="modal-h-01" style={{padding: type === LIVE_PRACTICE ? "21px 15px" : ''}}>
                    {type !== LIVE_PRACTICE && (
                      <SimpleMultiSelector
                        type={{
                          name: 'Period',
                          types: periods.map((period) => ({ value: period, name: period.drillType })),
                          title: 'PERIOD',
                          filterKey: FILTER_KEYS.PERIODS
                        }}
                        show={showFilter2 === 0}
                        close={() => setShowFilter2(-1)}
                        open={() => setShowFilter2(0)}
                      />
                    )}
                    {/*<Dropdown className="intensive">
                     <Dropdown.Toggle id="dropdown-basic" className="btn-border">
                     <label>PERIOD</label>
                     All Periods
                     </Dropdown.Toggle>
                     <Dropdown.Menu>
                     <div className="p-h-01">
                     Select All
                     <div className="p-i-01">
                     <input type="checkbox" id="id-name--20" name="set-name" className="switch-input"/>
                     <label htmlFor="id-name--20" className="switch-label"/>
                     </div>
                     </div>
                     <div className="p-b-01">
                     <div className="p-b-03">
                     <ul>
                     {list}
                     </ul>
                     </div>
                     </div>
                     <div className="footer-s">
                     <button className="btn-01">Cancel</button>
                     <button className="btn-02">Apply</button>
                     </div>
                     </Dropdown.Menu>
                     </Dropdown>*/}
                      </div>
                  <Tabs defaultActiveKey="home" transition={false} id="noanim-tab-example" className="modal-001">
                    <Tab eventKey="home" title={<span><ChartLogo /> CHART</span>}>
                      <div className="tab-body">
                        {/* <h6> FLIGHT TYPE AIR DISTANCE (YDS) BY PERIOD </h6>
                         <div className="graph-001">
                         <img src="/assets/images/graph-06.png" alt="" className="img-fluid" style={{opacity: 0}}/>
                         </div> */}
                        <Row>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. INITIAL AIR SPEED (YDS)"
                              current={playerBallData[0].avgInitAirSpeedInMph}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. AIR DIST. (YDS)"
                              current={playerBallData[0].avgAirDistInYards}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. INITIAL ROTATION (RPM)"
                              current={playerBallData[0].avgInitRotation}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. MAX AIR SPEED (MPH)"
                              current={playerBallData[0].maxAirSpeedInMph}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. FLIGHT DURATION (S)"
                              current={playerBallData[0].avgFlightDurInSec}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. MAX ROTATION (RPM)"
                              current={playerBallData[0].maxRotation}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. PEAK HEIGHT (FT)"
                              current={playerBallData[0].avgPeakHeightInFeet}
                              target="75.5%" flag
                            />
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                    <Tab eventKey="data" title={<span><DataLogo /> DATA</span>}>
                      <div className="tab-body data-body">
                        <Table responsive>
                          <thead>
                          <div>
                            <div className="title-m">DIS/TIME/SPRINTS BY TEAM ZONE</div>
                          </div>
                          <tr>
                            <th style={{ width: '45%' }}>METRIC TITLE</th>
                            <th style={{ width: '13%' }} className="l-c">INITIAL AIR SPEED (YDS)</th>
                            <th style={{ width: '10%' }} className="l-c">INITIAL ROT. (RPM)</th>
                            <th style={{ width: '10%' }} className="l-c">FLIGHT DURATION</th>
                            <th style={{ width: '10%' }} className="l-c">PEAK HEIGHT (FT)</th>
                            <th style={{ width: '10%' }} className="l-c">AIR DIST. (YDS)</th>
                          </tr>
                          </thead>
                          <tbody>
                          {metrics}
                          </tbody>
                        </Table>
                      </div>
                    </Tab>
                  </Tabs>
                </Tab>
                : (playerData.position === 'QB' || playerData.position === 'K' || playerData.position === 'P') ?
                <Tab eventKey='ball' title="Ball Metrics">
                  <Loader forceMessage={MESSAGES.EMPTY_BALL_FLIGHTS} style={{height: '520px'}} />
                </Tab>  
                :
               null 
             }
            </Tabs>
          </Modal.Body>
          </Loader>
        </> :
        <>
        {playerBallData && playerBallData[0].playersList.length > 0 ?
        <Modal.Header closeButton className="modal-practices">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="header-p">
            <div className="p-g">
              <label className="p-01">
                  { playerBallData && playerBallData[0].playersList[0].playerName != ''? playerBallData[0].playersList[0].playerName : playerData ? playerData.name : playerInfo.name }
              </label>
              <label className="p-02">
                <img src={'/assets/images/logos/' + (dataTeam as TeamData).teamAbbrName + '.svg'} width="20px"
                     alt="" />
                {(dataTeam as TeamData).teamFullName}
                <span>•</span> #{playerBallData && playerBallData[0].playersList? playerBallData[0].playersList[0].jerseyNumber : playerData ? playerData.jersey : playerInfo.jerseyNumber }
                <span>•</span> {playerBallData && playerBallData[0].playersList? playerBallData[0].playersList[0].position : playerData ? playerData.position : playerInfo.position}</label>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
        : null }
        <Modal.Body className="modal-body-00">
        {(playerBallData && playerBallData[0].playersList.length > 0) && 
        (playerBallData[0]?.playersList[0].position === 'QB' || playerBallData[0]?.playersList[0].position === 'K' || 
          playerBallData[0]?.playersList[0].position === 'P'|| playerBallData[0]?.playersList[0].position === 'LS') ?
            playerData && playerData.metrics ? null :
           <Tabs  defaultActiveKey={initialTab} id="uncontrolled-tab-example" className="modal-000" >
             <Tab eventKey="performance-01" title="Performance">
               <Loader style={{height: '520px'}} />
                </Tab>
                <Tab eventKey='ball' title="Ball Metrics">
                <div className="modal-h-01" style={{padding: type === LIVE_PRACTICE ? "21px 15px" : ''}} >
                    {type !== LIVE_PRACTICE && (
                      <SimpleMultiSelector
                        type={{
                          name: 'Period',
                          types: periods.map((period) => ({ value: period, name: period.drillType })),
                          title: 'PERIOD',
                          filterKey: FILTER_KEYS.PERIODS
                        }}
                        show={showFilter2 === 0}
                        close={() => setShowFilter2(-1)}
                        open={() => setShowFilter2(0)}
                      />
                    )}
                      </div>
                  <Tabs defaultActiveKey="home" transition={false} id="noanim-tab-example" className="modal-001">
                    <Tab eventKey="home" title={<span><ChartLogo /> CHART</span>}>
                      <div className="tab-body">
                        <Row>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. INITIAL AIR SPEED (YDS)"
                              current={playerBallData[0].avgInitAirSpeedInMph}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. AIR DIST. (YDS)"
                              current={playerBallData[0].avgAirDistInYards}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. INITIAL ROTATION (RPM)"
                              current={playerBallData[0].avgInitRotation}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. MAX AIR SPEED (MPH)"
                              current={playerBallData[0].maxAirSpeedInMph}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. FLIGHT DURATION (S)"
                              current={playerBallData[0].avgFlightDurInSec}
                              target="75.5%" flag
                            />
                            <Metric
                              label="AVG. MAX ROTATION (RPM)"
                              current={playerBallData[0].maxRotation}
                              target="75.5%" flag
                            />
                          </Col>
                          <Col lg={3} xs={3}>
                            <Metric
                              label="AVG. PEAK HEIGHT (FT)"
                              current={playerBallData[0].avgPeakHeightInFeet}
                              target="75.5%" flag
                            />
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                    <Tab eventKey="data" title={<span><DataLogo /> DATA</span>}>
                      <div className="tab-body data-body">
                        <Table responsive>
                          <thead>
                          <div>
                            <div className="title-m">DIS/TIME/SPRINTS BY TEAM ZONE</div>
                          </div>
                          <tr>
                            <th style={{ width: '45%' }}>METRIC TITLE</th>
                            <th style={{ width: '13%' }} className="l-c">INITIAL AIR SPEED (YDS)</th>
                            <th style={{ width: '10%' }} className="l-c">INITIAL ROT. (RPM)</th>
                            <th style={{ width: '10%' }} className="l-c">FLIGHT DURATION</th>
                            <th style={{ width: '10%' }} className="l-c">PEAK HEIGHT (FT)</th>
                            <th style={{ width: '10%' }} className="l-c">AIR DIST. (YDS)</th>
                          </tr>
                          </thead>
                          <tbody>
                          {metrics}
                          </tbody>
                        </Table>
                      </div>
                    </Tab>
                  </Tabs>
                  
                </Tab>
              </Tabs>
                : 
                <>
                      <Loader style={{height: '655px'}}/>
                </>
              }
              
        </Modal.Body>
        </>}
    </Modal>
  </>;
};

export default PlayerBallMetricsModal;
